// extracted by mini-css-extract-plugin
module.exports = {"block":"LoadingBlock_block__rWSdF","loadingBlock":"LoadingBlock_loadingBlock__TbV94","loading":"LoadingBlock_loading__3cF7e"};